import { useMemo } from 'react'
import { sanitizeRichTextForDisplay } from '~/shared/lib/rich-text'
import { cn } from '~/shared/lib/utils'

export const RICH_TEXT_CONTENT_CLASSES =
  'break-words [&_a]:font-medium [&_a]:text-brand-subtle-foreground [&_a]:underline [&_a]:underline-offset-2 [&_b]:font-semibold [&_strong]:font-semibold [&_h1]:font-semibold [&_h2]:font-semibold [&_h3]:font-semibold [&_h4]:font-semibold [&_h5]:font-semibold [&_h6]:font-semibold [&_li]:my-0.5 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:my-2 [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&>:first-child]:mt-0 [&>:last-child]:mb-0'

interface RichTextContentProps {
  html: string
  className?: string
}

export function RichTextContent({ html, className }: RichTextContentProps) {
  const sanitized = useMemo(() => sanitizeRichTextForDisplay(html), [html])
  return (
    <div
      className={cn(RICH_TEXT_CONTENT_CLASSES, className)}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: sanitised with DOMPurify against the shared allowlist
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  )
}
